import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useGetAllActionTrackerQuery } from "store/slices/apis/actionTrackerSlice";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";


const ActionTrackerListPopUp = (props) => {
    const { open, handleClose, data, columns } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);

    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    const projectType = localStorage.getItem("projectType");

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    const actionTrackerList = useGetAllActionTrackerQuery({ ...data, ProjectId: projectId, ProjectType:projectType, SortBy: sortBy, SortOrder: sortOrder, PageNumber: pageNumber, PageSize: pageSize, isActive: true })

    const dispatch = useDispatch();


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        // const updatedFilters = {
        //     ...filters,
        //     SortBy: property,
        //     SortOrder: isAsc ? 'desc' : 'asc'
        // };

        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
    };

    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isSuccess) {
    //         if (!addActionTrackerRes?.data?.status) {
    //             openNotification(addActionTrackerRes?.data?.message, 'success')
    //             handleClose();
    //         } else {
    //             openNotification(addActionTrackerRes?.data?.message, 'error')
    //         }
    //     }
    // }, [addActionTrackerRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isError) {
    //         if (addActionTrackerRes?.error?.data?.status == 'fail') {
    //             openNotification(addActionTrackerRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification('Something went wrong!', 'error')
    //         }
    //         // cancel();
    //     }
    // }, [addActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "3px", borderTopRightRadius: "3px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#FFFFFF",
                pb: 2,
                pt: 2,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "18px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Action Tracker
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                            data={actionTrackerList?.data?.data}
                            createSortHandler={handleRequestSort}
                            loading={loading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={actionTrackerList?.data?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ActionTrackerListPopUp;
